import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Main.css';
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import Carousel from '../Carousel/Carousel.js';
import VideoButton from '../VideoButton/VideoButton.js';
import NewsLoader from '../NewsLoader/NewsLoader.js';
import { getApiBaseUrl } from '../../utils/api.js';
import { getNewsCover } from '../../utils/news.js';

function Main() {
  const [news, setNews] = useState([]);
  const [isNewsLoading, setIsNewsLoading] = useState(true);

  useEffect(() => {
    fetch(`${getApiBaseUrl()}/api/news`)
      .then((res) => res.json())
      .then((data) => setNews(data))
      .catch((err) => console.error(err))
      .finally(() => setIsNewsLoading(false));
  }, []);

  const latestNews = news.slice(0, 4);

  return (
    <>
      <Header />
      <main className="main">
        <section className="main__slider">
          <Carousel />
        </section>
        <section className="main__img-links">
          <div className="main__img-links-container">
            <a href="https://вдпо.рф/virtual" target="_blanck">
              <div className="main__img-link-container">
                <div className="main__img-links-bg-one"></div>
                <h2 className="main__img-links-title">
                  Пожарно-техническая выставка
                </h2>
                <div className="main__img-links-overlay"></div>
              </div>
            </a>
            <Link to="/volunteers/" className="main__img-link">
              <div className="main__img-link-container">
                <div className="main__img-links-bg-two"></div>
                <h2 className="main__img-links-title">
                  Вступайте в ряды добровольцев
                </h2>
                <div className="main__img-links-overlay"></div>
              </div>
            </Link>
            <a
              href="https://vdpo.ru//main/profilakticheskaya-rabota-s-naseleniem/uchimsya-s-vdpo-videoroliki"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="main__img-link-container">
                <div className="main__img-links-bg-three"></div>
                <h2 className="main__img-links-title">Учимся с ВДПО</h2>
                <div className="main__img-links-overlay"></div>
              </div>
            </a>
            <Link to="/vdpo-history/" className="main__img-link">
              <div className="main__img-link-container">
                <div className="main__img-links-bg-four"></div>
                <h2 className="main__img-links-title">
                  История развития ВДПО
                </h2>
                <div className="main__img-links-overlay"></div>
              </div>
            </Link>
          </div>
        </section>
        <section className="main__news">
          <h2 className="main__news-title">Новости</h2>
          {isNewsLoading ? (
            <div className="main__news-loading">
              <NewsLoader text="Загрузка новостей..." />
            </div>
          ) : (
            <div className="main__news-container">
              {latestNews.map((item) => (
                <div className="main__news-container-card" key={item._id}>
                  <p className="main__news-container-card-date">{item.date}</p>
                  <Link
                    to={`/news/${item._id}/`}
                    className="main__news-container-card-link"
                  >
                    <h3 className="main__news-container-card-title">
                      {item.title}
                    </h3>
                    <img
                      src={getNewsCover(item)}
                      alt={item.title}
                      className="main__news-container-card-img"
                    />
                  </Link>
                </div>
              ))}
            </div>
          )}
          <div className="main__news-container-for-button">
            <Link to="/all-news/" className="main__news-button-all-news">
              Все новости &#8594;
            </Link>
          </div>
        </section>
        <section className="main__schedule">
          <div className="main__schedule-header">
            <p className="main__schedule-kicker">Календарь событий</p>
            <h2 className="main__schedule-title">Расписание</h2>
            <p className="main__schedule-lead">
              Ближайшие публикации, мероприятия и тематические материалы
              Самарского областного отделения ВДПО.
            </p>
          </div>
          {isNewsLoading ? (
            <div className="main__schedule-loading">
              <NewsLoader text="Загрузка расписания..." />
            </div>
          ) : (
            <div className="main__schedule-container">
              {latestNews.map((item) => (
                <div className="main__schedule-container-card" key={item._id}>
                  <p className="main__schedule-container-card-date">
                    {item.date}
                  </p>
                  <Link
                    to={`/news/${item._id}/`}
                    className="main__schedule-container-card-link"
                  >
                    <h3 className="main__schedule-container-card-title">
                      {item.title}
                    </h3>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </section>
        <section className="main__videoButton">
          <VideoButton />
        </section>
      </main>
      <Footer />
    </>
  );
}

export default Main;
